import { n as e } from "./PortalContainerContext-Cz7eWR3N.js";
import { i as t, n, r, t as i, u as a } from "./useVoiceUpload-5WFawI3J.js";
import { t as o } from "./useFlxFillHeight-qOgJEo-e.js";
import { createContext as s, useCallback as c, useContext as l, useEffect as u, useMemo as d, useRef as f, useState as p } from "react";
import { useObservableState as m, useSubscription as h } from "observable-hooks";
import { CHAT_FAB_NOTIFICATION_CLEAR_DELAY_MS as g, ChatDisplayType as _, ChatMessageType as v, activeChatSessionIdStore as y, buildAttachmentsMessagePayload as b, buildMessageTimeGroupLabels as x, chatStore as S, clearConversationsSearch as C, computeChatFabNotificationCount as w, config as T, conversationsListPaginationStore as E, conversationsSearchStore as D, detachChat as ee, fetchDocument as O, formatDateWithAppSettings as te, formatMessageTimestamp as k, getActiveChatSessionId as ne, getLastAgentSuggestions as re, getStaticAssetByKey as A, getUiFlowType as j, getUrlQueryParamValue as ie, groupSessionsByDate as ae, initChat as oe, initChatSession as se, loadChatSessionHistory as ce, loadConversationsList as M, loadMoreConversations as le, localizeString as N, mapConversationsToSearchSessions as ue, markChatFabSeen as de, normalizeSuggestedPrompts as fe, requestConversationsSearch as P, resolveChatSessionId as pe, resolveMessageActionsConfig as F, resolveMessageTimestamp as me, setActiveChatSessionId as he, showToast as ge, uiFlowType$ as I, updateUrlWithQueryParam as _e, uploadChatFilesAndWait as ve } from "@flowx/core-sdk";
import { clsx as L } from "clsx";
import { EMPTY as R, combineLatest as ye, map as z } from "rxjs";
import { ThemeComponent as B, applyChatAgentMessageCustomStyles as be, applyChatErrorMessageCustomStyles as xe, applyChatFileAttachmentsCustomStyles as Se, applyChatFileItemCustomStyles as Ce, applyChatHeaderCustomStyles as we, applyChatHistoryCustomStyles as Te, applyChatInputCustomStyles as Ee, applyChatMessagesCustomStyles as De, applyChatSuggestedPromptsCustomStyles as Oe, applyChatUserAttachedFilesCustomStyles as ke, applyChatUserFileItemCustomStyles as Ae, applyChatUserMessageCustomStyles as je, applyChatUserVoiceMessageCustomStyles as Me, applyChatVoiceInputCustomStyles as Ne, applyWrapperStyles as Pe } from "@flowx/core-theme";
import { getIconAsset as V, getThemingClassName as H, useCustomStyles as U, usePositionStyles as W } from "@flowx/react-theme";
import { FlxChat as G, FlxChatHeader as Fe, FlxChatHistory as Ie, FlxChatHistoryItem as Le, FlxChatHistorySection as Re, FlxChatInput as ze, FlxChatMessage as Be, FlxChatMessageActions as Ve, FlxChatMessageFeedback as He, FlxChatMessages as Ue, FlxChatReasoning as We, FlxChatSuggestedPrompts as Ge, FlxIcon as Ke, getFileExtension as qe } from "@flowx/react-ui-toolkit";
import { Fragment as Je, jsx as K, jsxs as Ye } from "react/jsx-runtime";
import { isEqual as Xe } from "lodash";
import { Popover as q } from "@base-ui/react/popover";
import './FlxChatWrapper.css';//#region \0rolldown/runtime.js
var Ze = Object.create, Qe = Object.defineProperty, J = Object.getOwnPropertyDescriptor, $e = Object.getOwnPropertyNames, et = Object.getPrototypeOf, tt = Object.prototype.hasOwnProperty, nt = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Y = (e, t) => {
	let n = {};
	for (var r in e) Qe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Qe(n, Symbol.toStringTag, { value: "Module" }), n;
}, rt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = $e(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !tt.call(e, s) && s !== n && Qe(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = J(t, s)) || r.enumerable
	});
	return e;
}, it = (e, t, n) => (n = e == null ? {} : Ze(et(e)), rt(t || !e || !e.__esModule || !tt.call(e, "default") ? Qe(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), at = (e) => {
	let [t, n] = p(""), [r, i] = p({
		query: "",
		sessions: [],
		loading: !1
	}), a = c((t) => {
		n(t), P(e, t);
	}, [e]);
	u(() => () => C(), []);
	let o = d(() => ye([D.stream$, y.stream$]).pipe(z(([e, t]) => ({
		search: e,
		currentId: t
	}))), []);
	return h(o, ({ search: e, currentId: t }) => {
		i({
			query: e.query,
			sessions: ue(e.results, t),
			loading: e.loading
		});
	}), {
		searchText: t,
		onSearchChange: a,
		clearSearch: c(() => {
			n(""), C();
		}, []),
		isSearchActive: r.query.length > 0,
		appliedQuery: r.query,
		searchSessions: r.sessions,
		searchLoading: r.loading
	};
}, ot = s(null), st = () => l(ot), ct = async (e) => O(e), lt = ({ messages: t, reasoning: n, showSuggestedPrompts: r, agentSuggestions: i, config: a, avatars: o, icons: s, onSendMessage: c, onSendSuggestedPrompt: l, onSendConfiguredPrompt: u, onMessageCopied: f, onNewChat: p, headerControls: m, sendAriaLabel: h, sendTooltip: g, stopAriaLabel: _, stopTooltip: y, voiceMicAriaLabel: b, onToggleFullscreen: x, isFullscreen: S, showFullscreenToggle: C, onClose: w, displayMode: E, showHeaderAvatar: D, hideHeader: ee = !1, headerActionIcons: O, activeView: ne = "chat", onHistory: re, onBackFromHistory: A, chatSessions: j, onSelectSession: ie, onLoadMoreSessions: oe, hasMoreSessions: se, loadingMoreSessions: ce, emptyStateText: M, searchValue: le, onSearchChange: N, onSearchClear: ue, searchPlaceholder: de, searchClearAriaLabel: fe, searchHighlightText: P, sessionGroupLabels: pe, headerTooltips: F, hasMoreMessages: me, loadingMore: he, onLoadMore: ge, classNames: I, onVoiceMessage: _e, showVoiceInput: ve, voiceLabels: R, onStopResponse: ye, inputDisabled: z = !1, inputDisabledTooltip: B, showFileUpload: be, fileAccept: xe, fileMaxFiles: Se, fileMaxFilesSize: Ce, fileInvalidTypeError: we, fileCountExceededError: Te, fileSizeExceededError: Ee, attachmentsUploadError: De, attachments: Oe, onAttachmentsChange: ke, onAttachmentsMessage: Ae, attachmentsLabels: je, attachmentsDataTestId: Me, fileItemDataTestId: Ne, userAttachedFilesDataTestId: Pe, userFileItemDataTestId: V, dataTestIds: H, downloadFile: U, messageActionsConfig: W, messageTimeGroupLabels: G, locale: Ke, feedbackTarget: qe, onFeedbackChange: Xe, onFeedbackSubmit: q, onFeedbackRemove: Ze, onFeedbackCancel: Qe }) => {
	let J = e(), $e = (e, t) => {
		if (!W || e.isWelcome) return;
		let n = !!e.audioUrl || !!e.voiceMessageStatus, r = W.showCopyAction && !n && !!e.content && !e.hasError, i = W.showTimestamp && !!G && !!e.timestamp, a = W.showResponseFeedback && e.sender === "receiver" && !!e.messageId && !n && !!e.content && !e.hasError;
		if (!r && !i && !a) return;
		let o = e.timestamp instanceof Date ? e.timestamp.toISOString() : e.timestamp;
		return /* @__PURE__ */ K(Ve, {
			className: L(I.messageActions, I.messageActionsConfig),
			showTimestamp: i,
			showCopyAction: r,
			timestampLabel: i && G && e.timestamp ? k(e.timestamp, G, Ke) : void 0,
			timestampTooltip: i && o ? te(o, Ke) : void 0,
			copyText: e.content,
			copyIconPath: s.messageActionsIcons?.copyIcon,
			copySuccessIconPath: s.messageActionsIcons?.copySuccessIcon,
			copyAriaLabel: W.copyAriaLabel,
			copiedAriaLabel: W.copiedAriaLabel,
			onCopied: f,
			tooltipClassName: I.helperTooltip || void 0,
			tooltipContainer: J,
			alwaysVisible: t,
			dataTestId: W.dataTestId,
			showResponseFeedback: a,
			feedback: e.feedback?.value ?? null,
			thumbUpIconPath: s.messageActionsIcons?.thumbUpIcon,
			thumbUpSelectedIconPath: s.messageActionsIcons?.thumbUpSelectedIcon,
			thumbDownIconPath: s.messageActionsIcons?.thumbDownIcon,
			thumbDownSelectedIconPath: s.messageActionsIcons?.thumbDownSelectedIcon,
			thumbsUpAriaLabel: W.thumbsUpAriaLabel,
			thumbsDownAriaLabel: W.thumbsDownAriaLabel,
			onFeedbackChange: (t) => Xe?.(e.messageId, t),
			readOnly: z
		});
	}, et = (e) => e.hasError ? H?.errorMessage : e.sender === "receiver" ? H?.agentMessage : e.audioUrl || e.voiceMessageStatus ? H?.userVoiceMessage : H?.userMessage, tt = {
		displayMode: E,
		buttonClassName: L(I.headerButton),
		newChatLabel: a.newChatLabel,
		onNewChat: z ? void 0 : p,
		onToggleFullscreen: x,
		isFullscreen: S,
		showFullscreenToggle: C,
		onClose: w,
		newChatIcon: O?.newChatIcon ?? void 0,
		expandIcon: O?.expandIcon ?? void 0,
		collapseIcon: O?.collapseIcon ?? void 0,
		dockIcon: O?.dockIcon ?? void 0,
		backIcon: O?.backIcon ?? void 0,
		newChatTooltip: F?.newChat,
		historyTooltip: F?.history,
		expandTooltip: F?.expand,
		collapseTooltip: F?.minimize,
		dockTooltip: F?.dock,
		backTooltip: F?.back,
		tooltipClassName: I.historyItemTooltip,
		tooltipContainer: J
	}, nt = d(() => !j?.length || !pe ? [] : ae(j, pe), [j, pe]), Y = t.filter((e) => e.type !== v.AI_TRIGGER || e.sender !== "sender"), rt = Y[Y.length - 1]?.sender !== "receiver" || z ? void 0 : i?.length && !n ? /* @__PURE__ */ K(Ge, {
		prompts: i,
		onPromptSelected: l,
		className: L(I.suggestedPrompts, ...I.suggestedPromptsCustom) || void 0,
		tooltipClassName: I.helperTooltip || void 0,
		tooltipContainer: J,
		dataTestId: H?.suggestedPrompts
	}) : r && a?.suggestedPrompts?.length ? /* @__PURE__ */ K(Ge, {
		prompts: a.suggestedPrompts,
		title: a.suggestedPromptsTitle,
		onPromptSelected: (e) => u ? u(e) : c(e.label),
		className: L(I.suggestedPrompts, ...I.suggestedPromptsCustom) || void 0,
		tooltipClassName: I.helperTooltip || void 0,
		tooltipContainer: J,
		dataTestId: H?.suggestedPrompts
	}) : void 0;
	if (ne === "history") return /* @__PURE__ */ K(Ie, {
		"data-testid": H?.history,
		className: L(I.history, ...I.historyCustom),
		headerClassName: L(I.header, ...I.headerCustom, I.headerConfig),
		onBack: A,
		emptyStateText: M,
		title: a.historyTitle,
		onLoadMore: oe,
		hasMore: se,
		loadingMore: ce,
		searchValue: le,
		onSearchChange: N,
		onSearchClear: ue,
		searchPlaceholder: de,
		searchClearAriaLabel: fe,
		searchIconPath: O?.searchIcon,
		searchClearIconPath: O?.searchClearIcon,
		searchClassName: I.historySearch || void 0,
		...tt,
		children: nt.map((e) => /* @__PURE__ */ K(Re, {
			title: e.title,
			className: L(I.historySection),
			children: e.sessions.map((e) => /* @__PURE__ */ K(Le, {
				sessionId: e.sessionId,
				summary: e.summary,
				active: e.active,
				createdAt: e.createdAt,
				snippet: e.snippet,
				highlightText: P,
				onSelectSession: ie,
				className: L(I.historyItem),
				tooltipClassName: I.historyItemTooltip,
				tooltipContainer: J,
				locale: T()?.locale
			}, e.sessionId))
		}, e.code))
	});
	let it = {
		"data-testid": H?.header,
		className: L(I.header, ...I.headerCustom, I.headerConfig),
		chatAvatar: o.header,
		showAvatar: D,
		title: a.title,
		subtitle: a.subtitle,
		showSeparator: a.showSeparator,
		onHistory: re,
		historyIcon: O?.historyIcon ?? void 0,
		...tt
	};
	return /* @__PURE__ */ Ye(Je, { children: [
		!ee && (m ? /* @__PURE__ */ Ye("div", {
			className: "flx-chat-header-wrapper",
			children: [/* @__PURE__ */ K(Fe, { ...it }), /* @__PURE__ */ K("div", {
				className: "flx-chat-header-controls-slot",
				children: m
			})]
		}) : /* @__PURE__ */ K(Fe, { ...it })),
		/* @__PURE__ */ Ye(Ue, {
			"data-testid": H?.messages,
			hasMoreMessages: me,
			loadingMore: he,
			onLoadMore: ge,
			className: L(I.messages, I.userVoiceMessage, ...I.userVoiceMessageCustom, ...I.messagesCustom, I.messagesConfig),
			children: [Y.map(({ id: e, messageId: t, feedback: n, sender: r, content: i, hasError: c, audioUrl: l, voiceMessageStatus: u, audioDuration: d, onRetryVoice: f, files: p, timestamp: m }, h) => /* @__PURE__ */ K(Be, {
				message: {
					id: e,
					messageId: t,
					feedback: n,
					sender: r,
					content: i,
					hasError: c,
					audioUrl: l,
					voiceMessageStatus: u,
					audioDuration: d,
					onRetryVoice: f,
					files: p,
					timestamp: m
				},
				messageActions: $e(Y[h], h === Y.length - 1),
				suggestedPrompts: h === Y.length - 1 ? rt : void 0,
				chatAvatar: r === "receiver" ? o.agent : void 0,
				errorIcon: s.errorIcon || void 0,
				errorMessage: a.errorMessage,
				fetchAudio: ct,
				voicePlayIconPath: s.voiceMessageIcons?.playIcon,
				voicePauseIconPath: s.voiceMessageIcons?.pauseIcon,
				voiceRetryIconPath: s.voiceMessageIcons?.retryIcon,
				voiceSendingLabel: R?.sendingLabel,
				voiceErrorLabel: R?.errorLabel,
				voiceRetryAriaLabel: R?.retryAriaLabel,
				voiceMessageLabel: R?.messageLabel,
				voicePlayAriaLabel: R?.messagePlayAriaLabel,
				voicePauseAriaLabel: R?.messagePauseAriaLabel,
				voiceProgressAriaLabel: R?.progressAriaLabel,
				downloadIconPath: s.fileDownloadIcon || void 0,
				downloadFile: U,
				attachmentsLabels: je,
				userAttachedFilesDataTestId: Pe,
				userFileItemDataTestId: V,
				dataTestId: et(Y[h]),
				className: L(r === "receiver" ? I.agentMessage : I.userMessage, ...r === "receiver" ? I.agentMessageCustom : I.userMessageCustom, r === "receiver" ? I.agentConfig : I.userConfig, r !== "receiver" && I.userFileAttachments, r !== "receiver" && I.userFileAttachmentsCustom && [...I.userFileAttachmentsCustom], c && I.errorMessage, c && I.errorMessageCustom && [...I.errorMessageCustom])
			}, `${e}-${r}`)), n ? /* @__PURE__ */ K(We, {
				dataTestId: H?.reasoning,
				className: L(I.reasoning),
				message: a.thinkingMessage,
				avatar: o.agent
			}) : null]
		}),
		W ? /* @__PURE__ */ K(He, {
			open: !!qe,
			title: W.feedbackTitle,
			reasons: W.feedbackReasons,
			reason: qe?.feedback?.reason ?? null,
			comment: qe?.feedback?.comment ?? null,
			isEdit: !!qe?.feedback,
			placeholder: W.feedbackPlaceholder,
			commentError: W.feedbackCommentError,
			cancelLabel: W.feedbackCancelLabel,
			submitLabel: W.feedbackSubmitLabel,
			removeLabel: W.feedbackRemoveLabel,
			onSubmit: (e) => q?.(e),
			onCancel: () => Qe?.(),
			onRemove: () => Ze?.(),
			className: I.feedbackModal,
			headerClassName: I.feedbackModalHeader,
			bodyClassName: I.messageFeedback,
			textAreaClassName: I.feedbackTextArea,
			errorClassName: I.feedbackError,
			buttonClassName: I.button,
			container: J
		}) : null,
		/* @__PURE__ */ K(ze, {
			"data-testid": H?.input,
			textAreaDataTestId: H?.textInput,
			voiceInputDataTestId: H?.voiceInput,
			className: L(I.input, I.voiceInput, I.inputFileAttachments, ...I.inputCustom, ...I.voiceInputCustom, ...I.inputFileAttachmentsCustom, I.inputConfig),
			textAreaClassName: L(I.textArea),
			buttonClassName: L(I.button),
			inputPlaceholder: a.inputPlaceholder,
			sendAriaLabel: h,
			sendTooltip: g,
			stopAriaLabel: _,
			stopTooltip: y,
			tooltipClassName: I.helperTooltip || void 0,
			tooltipContainer: J,
			voiceMicAriaLabel: b,
			sendIconPath: s.sendIcon || void 0,
			voiceMicIconPath: s.voiceMicIcon || void 0,
			maxInputRows: typeof a.maxInputRows == "number" ? a.maxInputRows : void 0,
			sendMessage: c,
			messageInput: "",
			sendDisabled: n,
			inputDisabled: z,
			inputDisabledTooltip: B,
			onStopResponse: ye,
			stopIconPath: s.stopIcon || void 0,
			onVoiceMessage: _e,
			showVoiceInput: ve && !z,
			voiceCancelIconPath: s.voiceInputIcons?.cancelIcon,
			voiceConfirmIconPath: s.voiceInputIcons?.confirmIcon,
			voiceDeleteIconPath: s.voiceInputIcons?.deleteIcon,
			voicePlayIconPath: s.voiceInputIcons?.playIcon,
			voicePauseIconPath: s.voiceInputIcons?.pauseIcon,
			voiceListeningLabel: R?.listeningLabel,
			voiceMessageLabel: R?.voiceMessageLabel,
			voiceCancelAriaLabel: R?.cancelAriaLabel,
			voiceConfirmAriaLabel: R?.confirmAriaLabel,
			voiceDeleteAriaLabel: R?.deleteAriaLabel,
			voicePlayAriaLabel: R?.inputPlayAriaLabel,
			voicePauseAriaLabel: R?.inputPauseAriaLabel,
			voiceProgressAriaLabel: R?.progressAriaLabel,
			showFileUpload: be && !z,
			accept: xe,
			maxFiles: Se,
			maxFilesSize: Ce,
			invalidFileTypeError: we,
			filesExceededError: Te,
			filesSizeExceededError: Ee,
			uploadError: De,
			attachIconPath: s.attachFileIcon || void 0,
			deleteIconPath: s.fileDeleteIcon || void 0,
			attachmentsLabels: je,
			attachmentsDataTestId: Me,
			fileItemDataTestId: Ne,
			attachments: Oe,
			onAttachmentsChange: ke,
			onAttachmentsMessage: Ae
		})
	] });
}, ut = [], dt = ({ isOpen: e }) => {
	let [t, n] = p(0), r = m(y.stream$, ne()), i = m(S.stream$, S.get()), a = r && i?.[r]?.chatHistory || ut;
	return u(() => {
		if (!r) {
			n(0);
			return;
		}
		if (e) {
			de(r, a), n(0);
			return;
		}
		n(w(r, a));
	}, [
		e,
		a,
		r
	]), u(() => {
		if (!e) return;
		let t = setTimeout(() => n(0), g);
		return () => clearTimeout(t);
	}, [e]), t;
}, ft = (e) => d(() => {
	let t = (t) => e?.templateConfig?.find((e) => e?.componentIdentifier === t), n = (e, t) => e?.templateConfig?.find((e) => e?.componentIdentifier === t), r = t("CHAT_MESSAGES"), i = t("CHAT_HISTORY"), a = t("CHAT_INPUT"), o = n(r, "CHAT_USER_MESSAGE"), s = n(a, "CHAT_FILE_ATTACHMENTS"), c = n(r, "CHAT_USER_ATTACHED_FILES");
	return {
		header: t("CHAT_HEADER"),
		messages: r,
		input: a,
		agent: n(r, "CHAT_AGENT_MESSAGE"),
		user: o,
		reasoning: n(r, "CHAT_REASONING"),
		errorMessage: n(r, "CHAT_ERROR_MESSAGE"),
		history: i,
		historyItem: n(i, "CHAT_HISTORY_ITEM"),
		historySection: n(i, "CHAT_HISTORY_SECTION"),
		suggestedPrompts: n(r, "CHAT_SUGGESTED_PROMPTS"),
		userVoiceMessage: n(r, "CHAT_USER_VOICE_MESSAGE"),
		messageActions: n(r, "CHAT_MESSAGE_ACTIONS"),
		textInput: n(a, "CHAT_TEXT_INPUT"),
		voiceInput: n(a, "CHAT_VOICE_INPUT"),
		fileAttachments: s,
		fileItem: n(s, "CHAT_FILE_ITEM"),
		userAttachedFiles: c,
		userFileItem: n(c, "CHAT_USER_FILE_ITEM")
	};
}, [e?.templateConfig]), pt = {
	[_.FILL]: {
		chat: B.Chat,
		chatHeader: B.ChatHeader,
		chatMessages: B.ChatMessages,
		chatMessageActions: B.ChatMessageActions,
		chatMessageFeedback: B.ChatMessageFeedback,
		chatMessageFeedbackReason: B.ChatMessageFeedbackReason,
		chatInputArea: B.ChatInputArea,
		chatUserMessage: B.ChatUserMessage,
		chatUserVoiceMessage: B.ChatUserVoiceMessage,
		chatAgentMessage: B.ChatAgentMessage,
		chatErrorMessage: B.ChatErrorMessage,
		chatInput: B.ChatInput,
		chatVoiceInput: B.ChatVoiceInput,
		chatInputFileAttachments: B.ChatInputFileAttachments,
		chatInputFileItem: B.ChatInputFileItem,
		chatUserFileAttachments: B.ChatUserFileAttachments,
		chatUserFileItem: B.ChatUserFileItem,
		chatHeaderButton: B.ChatHeaderButton,
		chatHistory: B.ChatHistory,
		chatHistoryItem: B.ChatHistoryItem,
		chatHistorySection: B.ChatHistorySection,
		chatHistorySearch: B.ChatHistorySearch
	},
	[_.FLOATING]: {
		chat: B.ChatFloating,
		chatHeader: B.ChatHeaderFloating,
		chatMessages: B.ChatMessagesFloating,
		chatMessageActions: B.ChatMessageActionsFloating,
		chatMessageFeedback: B.ChatMessageFeedbackFloating,
		chatMessageFeedbackReason: B.ChatMessageFeedbackReasonFloating,
		chatInputArea: B.ChatInputAreaFloating,
		chatUserMessage: B.ChatUserMessageFloating,
		chatUserVoiceMessage: B.ChatUserVoiceMessageFloating,
		chatAgentMessage: B.ChatAgentMessageFloating,
		chatErrorMessage: B.ChatErrorMessageFloating,
		chatInput: B.ChatInputFloating,
		chatVoiceInput: B.ChatVoiceInputFloating,
		chatInputFileAttachments: B.ChatInputFileAttachmentsFloating,
		chatInputFileItem: B.ChatInputFileItemFloating,
		chatUserFileAttachments: B.ChatUserFileAttachmentsFloating,
		chatUserFileItem: B.ChatUserFileItemFloating,
		chatHeaderButton: B.ChatHeaderButtonFloating,
		chatHistory: B.ChatHistoryFloating,
		chatHistoryItem: B.ChatHistoryItemFloating,
		chatHistorySection: B.ChatHistorySectionFloating,
		chatHistorySearch: B.ChatHistorySearchFloating
	},
	[_.FULLSCREEN]: {
		chat: B.ChatFullScreen,
		chatHeader: B.ChatHeaderFullScreen,
		chatMessages: B.ChatMessagesFullScreen,
		chatMessageActions: B.ChatMessageActionsFullScreen,
		chatMessageFeedback: B.ChatMessageFeedbackFullScreen,
		chatMessageFeedbackReason: B.ChatMessageFeedbackReasonFullScreen,
		chatInputArea: B.ChatInputAreaFullScreen,
		chatUserMessage: B.ChatUserMessageFullScreen,
		chatUserVoiceMessage: B.ChatUserVoiceMessageFullScreen,
		chatAgentMessage: B.ChatAgentMessageFullScreen,
		chatErrorMessage: B.ChatErrorMessageFullScreen,
		chatInput: B.ChatInputFullScreen,
		chatVoiceInput: B.ChatVoiceInputFullScreen,
		chatInputFileAttachments: B.ChatInputFileAttachmentsFullScreen,
		chatInputFileItem: B.ChatInputFileItemFullScreen,
		chatUserFileAttachments: B.ChatUserFileAttachmentsFullScreen,
		chatUserFileItem: B.ChatUserFileItemFullScreen,
		chatHeaderButton: B.ChatHeaderButtonFullScreen,
		chatHistory: B.ChatHistoryFullScreen,
		chatHistoryItem: B.ChatHistoryItemFullScreen,
		chatHistorySection: B.ChatHistorySectionFullScreen,
		chatHistorySearch: B.ChatHistorySearchFullScreen
	}
}, mt = {
	showChatIcon: !0,
	showSeparator: !0,
	newChatLabel: "New chat",
	errorMessage: "Error message",
	canRegenerate: !0,
	regenerateLabel: "Regenerate",
	maxInputRows: 10,
	showAgentAvatar: !0
}, X = (e) => {
	if (!e || typeof e != "object") return null;
	let t = e.value, n = e.appId, r = `${typeof n == "string" ? n : ""}${typeof t == "string" ? t : ""}`;
	return r ? A(r) ?? null : null;
}, Z = (e, t) => {
	let n = V(e, t);
	return n ? A(n) ?? null : null;
}, ht = (e) => {
	if (!e || typeof e != "object" || Array.isArray(e)) return;
	let t = e;
	if (typeof t.src == "string" && typeof t.alt == "string") return {
		src: t.src,
		alt: t.alt
	};
}, gt = (e, t) => {
	let n = ft(e), r = n.header?.displayOptions?.flowxProps, i = n.input?.displayOptions?.flowxProps, a = n.textInput?.displayOptions?.flowxProps, o = n.agent?.displayOptions?.flowxProps, s = n.errorMessage?.displayOptions?.flowxProps, c = n.suggestedPrompts?.displayOptions?.flowxProps, l = n.history?.displayOptions?.flowxProps, u = n.fileAttachments?.displayOptions?.flowxProps, f = n.fileItem?.displayOptions?.flowxProps, p = d(() => {
		let e = t?.displayTypes, n = !e?.length || e.length === 1 && e[0] === _.FILL, i = {
			...mt,
			thinkingMessage: t?.thinkingMessage,
			welcomeMessage: t?.welcomeMessage,
			title: r?.title,
			subtitle: r?.subtitle,
			showSeparator: r?.showSeparator,
			hideNewConversation: r?.hideNewConversation,
			hideHistory: r?.hideHistory,
			showChatIcon: r?.showIcon,
			newChatLabel: r?.newChatLabel,
			showAgentAvatar: o?.showIcon,
			maxInputRows: a?.maxInputRows,
			inputPlaceholder: a?.placeholder,
			errorMessage: s?.genericError,
			regenerateLabel: s?.regenerateLabel,
			historyTitle: l?.title,
			hideHeader: n ? t?.hideHeader : void 0
		}, u = fe(c?.prompts), d = c?.title;
		return {
			...i,
			title: i.title ? N(i.title) : i.title,
			subtitle: i.subtitle ? N(i.subtitle) : i.subtitle,
			welcomeMessage: i.welcomeMessage ? N(i.welcomeMessage) : i.welcomeMessage,
			thinkingMessage: i.thinkingMessage ? N(i.thinkingMessage) : i.thinkingMessage,
			inputPlaceholder: i.inputPlaceholder ? N(i.inputPlaceholder) : i.inputPlaceholder,
			errorMessage: i.errorMessage ? N(i.errorMessage) : i.errorMessage,
			regenerateLabel: i.regenerateLabel ? N(i.regenerateLabel) : i.regenerateLabel,
			suggestedPrompts: u.map((e) => ({
				label: N(e.label),
				prompt: e.prompt
			})),
			suggestedPromptsTitle: d && N(d)
		};
	}, [
		r,
		i,
		a,
		o,
		s,
		c,
		l,
		t
	]), m = d(() => {
		let e = {};
		for (let t of [
			_.FILL,
			_.FLOATING,
			_.FULLSCREEN
		]) {
			let n = pt[t];
			e[t] = {
				headerIcon: X(r?.headerIcon) ?? Z(n.chatHeader, "headerIcon"),
				agentIcon: X(o?.agentIcon) ?? Z(n.chatAgentMessage, "agentIcon"),
				sendIcon: X(i?.sendIcon) ?? Z(n.chatInputArea, "sendMessageIcon"),
				stopIcon: Z(n.chatInputArea, "stopResponseIcon"),
				voiceMicIcon: Z(n.chatInputArea, "voiceInputIcon"),
				errorIcon: X(s?.errorIcon) ?? Z(n.chatErrorMessage, "errorIcon"),
				voiceInputIcons: {
					cancelIcon: Z(n.chatVoiceInput, "cancelIcon"),
					confirmIcon: Z(n.chatVoiceInput, "confirmIcon"),
					deleteIcon: Z(n.chatVoiceInput, "deleteIcon"),
					playIcon: Z(n.chatVoiceInput, "playIcon"),
					pauseIcon: Z(n.chatVoiceInput, "pauseIcon")
				},
				voiceMessageIcons: {
					playIcon: Z(n.chatUserVoiceMessage, "playIcon"),
					pauseIcon: Z(n.chatUserVoiceMessage, "pauseIcon"),
					retryIcon: Z(n.chatUserVoiceMessage, "retryIcon")
				},
				attachFileIcon: Z(n.chatInputArea, "attachFileIcon"),
				fileDeleteIcon: Z(n.chatInputFileItem, "deleteIcon"),
				fileDownloadIcon: Z(n.chatUserFileItem, "downloadIcon"),
				messageActionsIcons: {
					copyIcon: Z(n.chatMessageActions, "copyIcon"),
					copySuccessIcon: Z(n.chatMessageActions, "copySuccessIcon"),
					thumbUpIcon: Z(n.chatMessageActions, "thumbUpIcon"),
					thumbUpSelectedIcon: Z(n.chatMessageActions, "thumbUpSelectedIcon"),
					thumbDownIcon: Z(n.chatMessageActions, "thumbDownIcon"),
					thumbDownSelectedIcon: Z(n.chatMessageActions, "thumbDownSelectedIcon")
				}
			};
		}
		return e;
	}, [
		o?.agentIcon,
		r?.headerIcon,
		i?.sendIcon,
		s?.errorIcon
	]), h = d(() => ({
		showFileUpload: i?.fileAttachmentsEnabled ?? !1,
		accept: u?.accept ?? "*/*",
		maxFiles: u?.maxFiles ?? 10,
		maxFilesSize: u?.maxFilesSize ?? 5e6,
		invalidTypeError: N(u?.invalidFileType ?? ""),
		countExceededError: N(u?.filesExceeded ?? ""),
		sizeExceededError: N(u?.filesSizeExceeded ?? ""),
		dataTestId: u?.dataTestId,
		fileItemDataTestId: f?.dataTestId
	}), [
		i?.fileAttachmentsEnabled,
		u,
		f
	]), g = d(() => {
		let e = (e) => e?.displayOptions?.flowxProps?.dataTestId;
		return {
			header: e(n.header),
			messages: e(n.messages),
			input: e(n.input),
			textInput: e(n.textInput),
			voiceInput: e(n.voiceInput),
			agentMessage: e(n.agent),
			userMessage: e(n.user),
			errorMessage: e(n.errorMessage),
			userVoiceMessage: e(n.userVoiceMessage),
			reasoning: e(n.reasoning),
			suggestedPrompts: e(n.suggestedPrompts),
			history: e(n.history)
		};
	}, [n]), v = d(() => {
		let e = {};
		for (let t of [
			_.FILL,
			_.FLOATING,
			_.FULLSCREEN
		]) {
			let n = pt[t].chatHeader, i = pt[t].chatHistorySearch;
			e[t] = {
				newChatIcon: X(r?.newChatIcon) ?? Z(n, "newChatIcon"),
				expandIcon: Z(n, "expandIcon"),
				collapseIcon: Z(n, "collapseIcon"),
				dockIcon: Z(n, "dockIcon") ?? Z(n, "closeIcon"),
				historyIcon: X(r?.historyIcon) ?? Z(n, "historyIcon"),
				backIcon: X(r?.backIcon) ?? Z(n, "backIcon"),
				searchIcon: Z(i, "searchIcon"),
				searchClearIcon: Z(i, "clearIcon")
			};
		}
		return e;
	}, [
		r?.newChatIcon,
		r?.historyIcon,
		r?.backIcon
	]);
	return {
		chatConfig: p,
		chatIconsByMode: m,
		chatHeaderAvatar: d(() => {
			if (p.showChatIcon === !1) return;
			let e = m[_.FILL].headerIcon;
			return e ? {
				src: e,
				alt: "Chat header icon"
			} : ht(t?.chatAvatar);
		}, [
			p.showChatIcon,
			m,
			t?.chatAvatar
		]),
		headerActionIconsByMode: v,
		fileUploadConfig: h,
		dataTestIds: g,
		templateConfigs: n,
		chatHeaderFlowxProps: r,
		chatInputFlowxProps: i,
		chatTextInputFlowxProps: a,
		chatAgentFlowxProps: o,
		chatErrorFlowxProps: s
	};
}, _t = () => {
	let [e, t] = p([]), [n, r] = p(null), [i, a] = p(!0), [o, s] = p(!1), l = d(() => ye([S.stream$, y.stream$]).pipe(z(([e, t]) => ({
		store: e,
		currentId: t
	}))), []);
	return h(l, ({ store: e, currentId: n }) => {
		r(n);
		let i = Object.entries(e).filter(([, e]) => !e.isLocalOnly && e.isSessionUpdated).map(([e, t]) => ({
			sessionId: e,
			summary: t.summary,
			messageCount: t.messageCount,
			active: e === n,
			createdAt: t.createdAt
		}));
		t(i);
	}), h(E.stream$, (e) => {
		a(e.hasMore), s(e.loading);
	}), {
		sessions: e,
		activeSessionId: n,
		selectSession: c((e) => {
			he(e), _e("chatSessionId", e), ce(e);
		}, []),
		hasMoreSessions: i,
		loadingMoreSessions: o
	};
};
//#endregion
//#region libs/sdk/react/src/lib/hooks/useAttachmentsUpload.ts
function vt(e, t) {
	let [n, r] = p([]), [i, a] = p(null);
	return {
		attachments: n,
		setAttachments: r,
		uploadError: i,
		handleAttachmentsMessage: c(async ({ message: n, files: i }) => {
			a(null);
			try {
				let a = pe(), o = await ve(a, i), s = b(n, o);
				e.current?.(n, s), t?.(), r([]);
			} catch (e) {
				console.error("[AttachmentsUpload] Upload failed:", e);
				let t = N("@@sys_chat_attachments_upload_error");
				a(t), ge({
					messageType: "error",
					message: t,
					hideCloseButton: !0,
					closeInterval: 3e3,
					withTheme: !0
				});
			}
		}, [e, t]),
		clearAttachments: c(() => {
			r([]), a(null);
		}, [])
	};
}
//#endregion
//#region libs/sdk/react/src/lib/hooks/useResolveAudioUrls.ts
function yt(e, t) {
	let n = f(/* @__PURE__ */ new Map()), r = (e) => e.map((e) => {
		if (!e.audioUrl) return e;
		let t = n.current.get(e.audioUrl);
		return t ? {
			...e,
			audioUrl: t
		} : e;
	}), i = c((e, t) => {
		t instanceof Blob && n.current.set(e, URL.createObjectURL(t));
	}, []);
	return u(() => {
		let e = n;
		return () => {
			e.current.forEach((e) => {
				e.startsWith("blob:") && URL.revokeObjectURL(e);
			}), e.current.clear();
		};
	}, []), {
		applyCachedAudioUrls: r,
		seedCache: i
	};
}
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/utils/messageUtils.ts
var bt = () => typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`, xt = (e, t = "receiver") => e.map((e) => ({
	...e,
	id: e.id ?? bt(),
	sender: e.sender ?? t,
	timestamp: e.timestamp ?? /* @__PURE__ */ new Date(),
	type: e.type
})), St = (e) => ({
	id: bt(),
	content: e,
	sender: "receiver",
	timestamp: /* @__PURE__ */ new Date(),
	isWelcome: !0
}), Ct = (e) => {
	let t = pt[e], n = [
		"chat",
		"chatHeader",
		"chatMessages",
		"chatMessageActions",
		"chatMessageFeedback",
		"chatMessageFeedbackReason",
		"chatInputArea",
		"chatUserMessage",
		"chatUserVoiceMessage",
		"chatAgentMessage",
		"chatErrorMessage",
		"chatInput",
		"chatVoiceInput",
		"chatInputFileAttachments",
		"chatInputFileItem",
		"chatUserFileAttachments",
		"chatUserFileItem",
		"chatHeaderButton",
		"chatHistory",
		"chatHistoryItem",
		"chatHistorySection",
		"chatHistorySearch"
	], r = {};
	for (let e of n) r[e] = H(t[e]);
	return r;
}, wt = () => ({
	[_.FILL]: Ct(_.FILL),
	[_.FLOATING]: Ct(_.FLOATING),
	[_.FULLSCREEN]: Ct(_.FULLSCREEN)
}), Tt = (e, r = !1, a = {}) => {
	let [o, s] = p([]), l = f(!1), [g, _] = p(!1), [y, b] = p(!1), [x, S] = p([]), [C, w] = p(!1), [E, D] = p(!1), [O, te] = p(null), k = f(null), ne = f(null), A = f(null), j = m(I, null), ae = d(() => j?.chatWorkflow?.resDefId, [j]), ce = f(/* @__PURE__ */ new Map()), M = t(a), { applyCachedAudioUrls: le, seedCache: N } = yt(o, s), { pendingVoice: ue, handleVoiceMessage: de, handleRetryVoice: fe, clearPendingVoice: P, checkAndClearPendingVoice: pe } = n(N, k, _, a.voiceInput), { attachments: F, setAttachments: he, uploadError: ge, handleAttachmentsMessage: ve, clearAttachments: L } = vt(k, M.textMessageSent);
	return u(() => {
		r && (L(), P());
	}, [
		r,
		L,
		P
	]), u(() => {
		let t = !0;
		if (!ae) {
			s(xt([St(e.welcomeMessage || "Welcome to the chat!")]));
			return;
		}
		return _(!1), te(null), P(), ie("chatSessionId") || (b(!0), s(xt([St(e.welcomeMessage || "Welcome to the chat!")]))), oe({
			cache: !1,
			source: {
				type: "WORKFLOW",
				id: ae
			}
		}).then(({ sendMessage: e, chat$: n, loadMoreMessages: r, stopResponse: i }) => {
			t && (k.current = e, ne.current = r, A.current = i, te(n));
		}).catch((n) => {
			console.error("Error initializing chat:", n), t && s(xt([St(e.welcomeMessage || "Welcome to the chat!")]));
		}), () => {
			t = !1, ee();
		};
	}, [
		e.welcomeMessage,
		ae,
		P
	]), h(O ?? R, ({ chatHistory: t, loading: n, isLocalOnly: r, hasMoreMessages: i, loadingMore: a }) => {
		if (_(n), w(i ?? !1), D(a ?? !1), b(r), r) S([]), s([St(e.welcomeMessage || "Welcome to the chat!")]);
		else {
			S(re(t ?? []));
			let e = t?.filter((e) => e.message || e.type === v.AUDIO || e.type === v.ATTACHMENTS).map((e) => {
				let t = e._id ?? bt(), n = e.type === v.AUDIO, r;
				if (n && e.audioFile?.downloadPath) {
					let { apiUrl: t } = T();
					r = `${t}/document/${e.audioFile.downloadPath}`;
				}
				let i = e.type === v.ATTACHMENTS, a;
				if (i && e.files?.length) {
					let { apiUrl: t } = T();
					a = e.files.map((e) => {
						let n = e.originalFileName || e.downloadPath.split("/").pop() || e.downloadPath;
						return {
							name: n,
							extension: qe(n),
							mimeType: e.mimeType ?? "",
							downloadUrl: `${t}/document/${e.downloadPath}`
						};
					});
				}
				return {
					id: t,
					messageId: e.messageId,
					feedback: e.feedback ?? null,
					content: n ? "" : e.message || "",
					sender: e.actor === "human" ? "sender" : "receiver",
					timestamp: me(t, e.timestamp, ce.current),
					hasError: e.hasError,
					...r ? { audioUrl: r } : {},
					...n && e.audioFile?.duration ? { audioDuration: e.audioFile.duration } : {},
					...a ? { files: a } : {},
					type: e.type
				};
			}) ?? [];
			pe(e), s(le(e));
		}
	}), {
		messages: d(() => i(o, ue, (e, t) => ({
			id: e.id,
			content: "",
			sender: "sender",
			timestamp: /* @__PURE__ */ new Date(),
			voiceMessageStatus: e.status,
			audioDuration: e.duration,
			onRetryVoice: t,
			...e.downloadUrl ? { audioUrl: e.downloadUrl } : {}
		}), fe), [
			o,
			ue,
			fe
		]),
		reasoning: g,
		showSuggestedPrompts: y,
		agentSuggestions: x,
		handleSendMessage: c((e) => {
			l.current = !0, k.current && (k.current(e), M.textMessageSent());
		}, [M]),
		handleResendMessage: c((e) => {
			l.current = !0, k.current?.(e);
		}, []),
		handleSendSuggestedPrompt: c((e) => {
			l.current = !0, k.current && (k.current(e.label, {
				type: v.SUGGESTED_PROMPT,
				label: e.label,
				prompt: e.prompt || ""
			}), M.agentPromptSelected());
		}, [M]),
		handleSendConfiguredPrompt: c((e) => {
			l.current = !0, k.current && (k.current(e.label), M.configuredPromptSelected(e.label));
		}, [M]),
		handleNewChat: c(() => {
			se(), _e("chatSessionId", null), l.current = !1, ce.current.clear(), s([St(e.welcomeMessage || "Welcome to the chat!")]), _(!1), b(!0), S([]), P(), L();
		}, [
			e.welcomeMessage,
			P,
			L
		]),
		hasMoreMessages: C,
		loadingMore: E,
		handleLoadMore: c(() => {
			C && !E && ne.current?.();
		}, [C, E]),
		handleVoiceMessage: de,
		handleStopResponse: c(() => {
			A.current?.();
		}, []),
		attachments: F,
		onAttachmentsChange: he,
		attachmentsUploadError: ge,
		handleAttachmentsMessage: ve
	};
}, Et = {
	fill: [],
	floating: [],
	fullscreen: []
}, Dt = [
	"fill",
	"floating",
	"fullscreen"
];
function Ot(e) {
	switch (e) {
		case B.ChatHeader: return (e) => we(e);
		case B.ChatMessages: return (e) => De(e);
		case B.ChatAgentMessage: return (e) => be(e);
		case B.ChatUserMessage: return (e) => je(e);
		case B.ChatUserVoiceMessage: return (e) => Me(e);
		case B.ChatUserFileAttachments: return (e) => ke(e);
		case B.ChatUserFileItem: return (e) => Ae(e);
		case B.ChatInput: return (e) => Ee(e);
		case B.ChatVoiceInput: return (e) => Ne(e);
		case B.ChatInputFileAttachments: return (e) => Se(e);
		case B.ChatInputFileItem: return (e) => Ce(e);
		case B.ChatErrorMessage: return (e) => xe(e);
		case B.ChatSuggestedPrompts: return (e) => Oe(e);
		case B.ChatHistory: return (e) => Te(e);
		default: return null;
	}
}
var Q = (e, t) => {
	let [n, r] = p(Et);
	return u(() => {
		let i = Ot(t);
		if (!i || !e) {
			r((e) => Xe(e, Et) ? e : Et);
			return;
		}
		let a = {
			fill: [],
			floating: [],
			fullscreen: []
		};
		for (let t of Dt) {
			let n = e[t];
			a[t] = n ? [Pe(n), i(n)].filter(Boolean) : [];
		}
		Xe(a, n) || r(a);
	}, [
		e,
		n,
		t
	]), n;
}, kt = (e, t) => {
	let n = d(() => wt(), []), r = n[_.FILL].chat ?? null, i = n[_.FLOATING].chat ?? null, a = n[_.FULLSCREEN].chat ?? null, o = n[_.FILL].chatVoiceInput ?? null, s = n[_.FLOATING].chatVoiceInput ?? null, c = n[_.FULLSCREEN].chatVoiceInput ?? null, l = n[_.FILL].chatUserVoiceMessage ?? null, u = n[_.FLOATING].chatUserVoiceMessage ?? null, f = n[_.FULLSCREEN].chatUserVoiceMessage ?? null, p = n[_.FILL].chatHeader ?? null, m = n[_.FLOATING].chatHeader ?? null, h = n[_.FULLSCREEN].chatHeader ?? null, g = n[_.FILL].chatMessages ?? null, v = n[_.FLOATING].chatMessages ?? null, y = n[_.FULLSCREEN].chatMessages ?? null, b = n[_.FILL].chatInputArea ?? null, x = n[_.FLOATING].chatInputArea ?? null, S = n[_.FULLSCREEN].chatInputArea ?? null, C = n[_.FILL].chatUserMessage ?? null, w = n[_.FLOATING].chatUserMessage ?? null, T = n[_.FULLSCREEN].chatUserMessage ?? null, E = n[_.FILL].chatAgentMessage ?? null, D = n[_.FLOATING].chatAgentMessage ?? null, ee = n[_.FULLSCREEN].chatAgentMessage ?? null, O = n[_.FILL].chatErrorMessage ?? null, te = n[_.FLOATING].chatErrorMessage ?? null, k = n[_.FULLSCREEN].chatErrorMessage ?? null, ne = n[_.FILL].chatInput ?? null, re = n[_.FLOATING].chatInput ?? null, A = n[_.FULLSCREEN].chatInput ?? null, j = n[_.FILL].chatHeaderButton ?? null, ie = n[_.FLOATING].chatHeaderButton ?? null, ae = n[_.FULLSCREEN].chatHeaderButton ?? null, oe = n[_.FILL].chatHistory ?? null, se = n[_.FLOATING].chatHistory ?? null, ce = n[_.FULLSCREEN].chatHistory ?? null, M = n[_.FILL].chatHistoryItem ?? null, le = n[_.FLOATING].chatHistoryItem ?? null, N = n[_.FULLSCREEN].chatHistoryItem ?? null, ue = n[_.FILL].chatHistorySection ?? null, de = n[_.FLOATING].chatHistorySection ?? null, fe = n[_.FULLSCREEN].chatHistorySection ?? null, P = H(B.HelperTooltip), pe = H(B.Button), F = H(B.Textarea), me = H(B.Error), he = H(B.Modal), ge = H(B.ModalHeader), I = e?.fill ?? {}, _e = e?.floating ?? {}, ve = e?.fullscreen ?? {}, L = e?.floating?.fab ?? {}, R = e?.fullscreen?.fab ?? {}, ye = L.notification ?? {}, z = R.notification ?? {}, be = e?.floating?.position ?? null, xe = e?.fullscreen?.position ?? null, Se = W({
		styles: be,
		isChat: !0
	}), Ce = W({
		styles: xe,
		isChat: !0
	}), we = U({
		styles: I,
		component: B.Chat
	}), Te = U({
		styles: _e,
		component: B.Chat
	}), Ee = U({
		styles: ve,
		component: B.Chat
	}), De = Q(t.header?.displayOptions?.style, B.ChatHeader), Oe = Q(t.messages?.displayOptions?.style, B.ChatMessages), ke = Q(t.agent?.displayOptions?.style, B.ChatAgentMessage), Ae = Q(t.user?.displayOptions?.style, B.ChatUserMessage), je = Q(t.userVoiceMessage?.displayOptions?.style, B.ChatUserVoiceMessage), Me = Q(t.input?.displayOptions?.style, B.ChatInput), Ne = Q(t.voiceInput?.displayOptions?.style, B.ChatVoiceInput), Pe = Q(t.errorMessage?.displayOptions?.style, B.ChatErrorMessage), V = Q(t.suggestedPrompts?.displayOptions?.style, B.ChatSuggestedPrompts), G = Q(t.history?.displayOptions?.style, B.ChatHistory), Fe = Q(t.fileAttachments?.displayOptions?.style, B.ChatInputFileAttachments), Ie = Q(t.fileItem?.displayOptions?.style, B.ChatInputFileItem), Le = Q(t.userAttachedFiles?.displayOptions?.style, B.ChatUserFileAttachments), Re = Q(t.userFileItem?.displayOptions?.style, B.ChatUserFileItem), ze = U({
		styles: L,
		component: B.ChatFabFloating
	}), Be = U({
		styles: R,
		component: B.ChatFabFullScreen
	}), Ve = U({
		styles: ye,
		component: B.ChatFabNotificationFloating
	}), He = U({
		styles: z,
		component: B.ChatFabNotificationFullScreen
	});
	return {
		classNamesByMode: n,
		chatClassName: r,
		chatClassNameFloating: i,
		chatClassNameFullScreen: a,
		chatVoiceInputClassName: o,
		chatVoiceInputClassNameFloating: s,
		chatVoiceInputClassNameFullScreen: c,
		chatUserVoiceMessageClassName: l,
		chatUserVoiceMessageClassNameFloating: u,
		chatUserVoiceMessageClassNameFullScreen: f,
		chatHeaderClassName: p,
		chatHeaderClassNameFloating: m,
		chatHeaderClassNameFullScreen: h,
		chatMessagesClassName: g,
		chatMessagesClassNameFloating: v,
		chatMessagesClassNameFullScreen: y,
		chatInputAreaClassName: b,
		chatInputAreaClassNameFloating: x,
		chatInputAreaClassNameFullScreen: S,
		chatUserMessageClassName: C,
		chatUserMessageClassNameFloating: w,
		chatUserMessageClassNameFullScreen: T,
		chatAgentMessageClassName: E,
		chatAgentMessageClassNameFloating: D,
		chatAgentMessageClassNameFullScreen: ee,
		chatErrorMessageClassName: O,
		chatErrorMessageClassNameFloating: te,
		chatErrorMessageClassNameFullScreen: k,
		textAreaClassName: ne,
		textAreaClassNameFloating: re,
		textAreaClassNameFullScreen: A,
		formTextAreaClassName: F,
		formErrorClassName: me,
		modalClassName: he,
		modalHeaderClassName: ge,
		chatHeaderButtonClassName: j,
		chatHeaderButtonClassNameFloating: ie,
		chatHeaderButtonClassNameFullScreen: ae,
		chatHistoryClassName: oe,
		chatHistoryClassNameFloating: se,
		chatHistoryClassNameFullScreen: ce,
		chatHistoryItemClassName: M,
		chatHistoryItemClassNameFloating: le,
		chatHistoryItemClassNameFullScreen: N,
		chatHistorySectionClassName: ue,
		chatHistorySectionClassNameFloating: de,
		chatHistorySectionClassNameFullScreen: fe,
		helperTooltipClassName: P,
		buttonClassName: pe,
		chatCustomClassName: we,
		chatFloatingCustomClassName: Te,
		chatFullscreenCustomClassName: Ee,
		chatHeaderCustomClassName: De.fill,
		chatHeaderCustomClassNameFloating: De.floating,
		chatHeaderCustomClassNameFullScreen: De.fullscreen,
		chatMessagesCustomClassName: Oe.fill,
		chatMessagesCustomClassNameFloating: Oe.floating,
		chatMessagesCustomClassNameFullScreen: Oe.fullscreen,
		chatAgentMessageCustomClassName: ke.fill,
		chatAgentMessageCustomClassNameFloating: ke.floating,
		chatAgentMessageCustomClassNameFullScreen: ke.fullscreen,
		chatUserMessageCustomClassName: Ae.fill,
		chatUserMessageCustomClassNameFloating: Ae.floating,
		chatUserMessageCustomClassNameFullScreen: Ae.fullscreen,
		chatInputCustomClassName: Me.fill,
		chatInputCustomClassNameFloating: Me.floating,
		chatInputCustomClassNameFullScreen: Me.fullscreen,
		chatErrorMessageCustomClassName: Pe.fill,
		chatErrorMessageCustomClassNameFloating: Pe.floating,
		chatErrorMessageCustomClassNameFullScreen: Pe.fullscreen,
		chatSuggestedPromptsCustomClassName: V.fill,
		chatSuggestedPromptsCustomClassNameFloating: V.floating,
		chatSuggestedPromptsCustomClassNameFullScreen: V.fullscreen,
		chatHistoryCustomClassName: G.fill,
		chatHistoryCustomClassNameFloating: G.floating,
		chatHistoryCustomClassNameFullScreen: G.fullscreen,
		chatUserVoiceMessageCustomClassName: je.fill,
		chatUserVoiceMessageCustomClassNameFloating: je.floating,
		chatUserVoiceMessageCustomClassNameFullScreen: je.fullscreen,
		chatVoiceInputCustomClassName: Ne.fill,
		chatVoiceInputCustomClassNameFloating: Ne.floating,
		chatVoiceInputCustomClassNameFullScreen: Ne.fullscreen,
		fabCustomClassNameFloating: ze,
		fabCustomClassNameFullScreen: Be,
		fabNotificationCustomClassNameFloating: Ve,
		fabNotificationCustomClassNameFullScreen: He,
		chatInputFileAttachmentsCustomStyles: Fe,
		chatInputFileItemCustomStyles: Ie,
		chatUserFileAttachmentsCustomStyles: Le,
		chatUserFileItemCustomStyles: Re,
		popupPositionClassNameFloating: Se,
		popupPositionClassNameFullscreen: Ce,
		chatHeaderConfigClassName: t.header?.displayOptions?.className ?? void 0,
		chatMessagesConfigClassName: t.messages?.displayOptions?.className ?? void 0,
		chatInputConfigClassName: t.input?.displayOptions?.className ?? void 0,
		chatAgentConfigClassName: t.agent?.displayOptions?.className ?? void 0,
		chatUserConfigClassName: t.user?.displayOptions?.className ?? void 0,
		chatReasoningConfigClassName: t.reasoning?.displayOptions?.className ?? void 0,
		chatMessageActionsConfigClassName: t.messageActions?.displayOptions?.className ?? void 0
	};
};
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/useFlxChatWrapperState.ts
function At(e) {
	let { displayOptions: { className: n, flowxProps: i } = {
		className: null,
		flowxProps: {}
	}, flowxUuid: o } = e ?? {
		displayOptions: {},
		flowxUuid: ""
	}, s = j()?.chatWorkflow?.resDefId, [l, u] = p("chat"), d = gt(e, i), f = d.chatInputFlowxProps?.disabled, m = a({
		config: d.templateConfigs.input,
		expression: f ?? ""
	}), { templateConfigs: h } = d, g = {
		chat: e,
		textInput: h.textInput,
		suggestedPrompts: h.suggestedPrompts,
		voiceInput: h.voiceInput,
		messageActions: h.messageActions
	}, _ = t(g), v = Tt(d.chatConfig, m, g), { messages: y, handleResendMessage: b } = v, S = c(() => {
		let e = [...y].reverse().find((e) => e.sender === "sender");
		e?.content && b(e.content);
	}, [y, b]), C = kt(e?.displayOptions?.style, d.templateConfigs), w = _t(), T = at(s), E = r(g.messageActions), D = c(async () => {
		if (s) try {
			await M(s);
		} catch (e) {
			console.error("Failed to load conversations list", e);
		}
		u("history");
	}, [s]), ee = c(() => {
		T.clearSearch(), u("chat");
	}, [T.clearSearch]), te = c(async () => {
		s && await le(s);
	}, [s]), k = c(() => {
		v.handleNewChat(), u("chat");
	}, [v.handleNewChat]), ne = c((e) => {
		w.selectSession(e), T.clearSearch(), u("chat");
	}, [w.selectSession, T.clearSearch]), re = c(async (e) => {
		if (!e.downloadUrl) return;
		let t = await O(e.downloadUrl);
		if (!t) return;
		let n = URL.createObjectURL(t), r = document.createElement("a");
		r.href = n, r.download = e.name, r.click(), URL.revokeObjectURL(n);
	}, []), A = d.templateConfigs.messageActions?.displayOptions?.flowxProps, ie = d.templateConfigs.messageActions ? F(A, N) : void 0;
	return {
		flowxUuid: o,
		className: n,
		flowxProps: i,
		displayOptions: e?.displayOptions,
		chatConfig: d.chatConfig,
		chatInputFlowxProps: d.chatInputFlowxProps,
		inputDisabled: m,
		inputDisabledTooltip: N("@@sys_chat_disabled_input"),
		chatIconsByMode: d.chatIconsByMode,
		headerActionIconsByMode: d.headerActionIconsByMode,
		fileUploadConfig: d.fileUploadConfig,
		userAttachedFilesDataTestId: d.templateConfigs.userAttachedFiles?.displayOptions?.flowxProps?.dataTestId,
		userFileItemDataTestId: d.templateConfigs.userFileItem?.displayOptions?.flowxProps?.dataTestId,
		dataTestIds: d.dataTestIds,
		messageActionsConfig: ie,
		feedbackTarget: E.feedbackTarget,
		handleFeedbackChange: E.handleFeedbackChange,
		handleFeedbackSubmit: E.handleFeedbackSubmit,
		handleFeedbackRemove: E.handleFeedbackRemove,
		handleFeedbackCancel: E.handleFeedbackCancel,
		messageTimeGroupLabels: x(N),
		messages: v.messages,
		reasoning: v.reasoning,
		showSuggestedPrompts: v.showSuggestedPrompts,
		agentSuggestions: v.agentSuggestions,
		hasMoreMessages: v.hasMoreMessages,
		loadingMore: v.loadingMore,
		handleLoadMore: v.handleLoadMore,
		handleSendMessage: v.handleSendMessage,
		handleSendSuggestedPrompt: v.handleSendSuggestedPrompt,
		handleSendConfiguredPrompt: v.handleSendConfiguredPrompt,
		chatAnalytics: _,
		handleNewChat: k,
		handleVoiceMessage: v.handleVoiceMessage,
		handleStopResponse: v.handleStopResponse,
		handleRegenerate: S,
		attachments: v.attachments,
		onAttachmentsChange: v.onAttachmentsChange,
		attachmentsUploadError: v.attachmentsUploadError,
		handleAttachmentsMessage: v.handleAttachmentsMessage,
		downloadAttachment: re,
		attachmentsLabels: {
			attachAriaLabel: N("@@sys_a11y_chat_attach_files"),
			removeAriaLabel: N("@@sys_a11y_chat_remove_file"),
			downloadAriaLabel: N("@@sys_a11y_chat_download_file")
		},
		activeView: l,
		handleOpenHistory: D,
		handleCloseHistory: ee,
		handleSelectSession: ne,
		handleLoadMoreSessions: te,
		chatSessions: w.sessions,
		hasMoreSessions: w.hasMoreSessions,
		loadingMoreSessions: w.loadingMoreSessions,
		searchText: T.searchText,
		handleSearchChange: T.onSearchChange,
		handleSearchClear: T.clearSearch,
		isSearchActive: T.isSearchActive,
		searchSessions: T.searchSessions,
		searchLoading: T.searchLoading,
		searchHighlightText: T.appliedQuery,
		searchPlaceholder: N("@@sys_chat_conversations_search_placeholder"),
		searchClearAriaLabel: N("@@sys_a11y_conversations_search_clear"),
		conversationsNoResultsText: N("@@sys_chat_conversations_no_results"),
		headerTooltips: {
			newChat: N("@@sys_chat_tooltip_new_chat"),
			history: N("@@sys_chat_tooltip_chat_history"),
			expand: N("@@sys_chat_tooltip_expand"),
			minimize: N("@@sys_chat_tooltip_minimize"),
			dock: N("@@sys_chat_tooltip_dock"),
			back: N("@@sys_chat_tooltip_back")
		},
		conversationsEmptyStateText: N("@@sys_chat_conversations_empty_state"),
		sessionGroupLabels: {
			sys_chat_time_group_today: N("@@sys_chat_time_group_today"),
			sys_chat_time_group_yesterday: N("@@sys_chat_time_group_yesterday"),
			sys_chat_time_group_previous_7_days: N("@@sys_chat_time_group_previous_7_days"),
			sys_chat_time_group_previous_30_days: N("@@sys_chat_time_group_previous_30_days"),
			sys_chat_time_group_older: N("@@sys_chat_time_group_older")
		},
		voiceLabels: {
			listeningLabel: N("@@sys_chat_voice_input_recording"),
			voiceMessageLabel: N("@@sys_chat_voice_input_message"),
			cancelAriaLabel: N("@@sys_a11y_chat_voice_input_cancel"),
			confirmAriaLabel: N("@@sys_a11y_chat_voice_input_confirm"),
			deleteAriaLabel: N("@@sys_a11y_chat_voice_input_delete"),
			inputPlayAriaLabel: N("@@sys_a11y_chat_voice_input_play"),
			inputPauseAriaLabel: N("@@sys_a11y_chat_voice_input_pause"),
			sendingLabel: N("@@sys_chat_voice_message_sending"),
			messageLabel: N("@@sys_chat_voice_message"),
			errorLabel: N("@@sys_chat_voice_message_error"),
			messagePlayAriaLabel: N("@@sys_a11y_chat_voice_message_play"),
			messagePauseAriaLabel: N("@@sys_a11y_chat_voice_message_pause"),
			retryAriaLabel: N("@@sys_a11y_chat_voice_message_retry"),
			progressAriaLabel: N("@@sys_a11y_chat_voice_message_progress")
		},
		chatHeaderAvatar: d.chatHeaderAvatar,
		chatHeaderConfigClassName: C.chatHeaderConfigClassName,
		chatMessagesConfigClassName: C.chatMessagesConfigClassName,
		chatInputConfigClassName: C.chatInputConfigClassName,
		chatAgentConfigClassName: C.chatAgentConfigClassName,
		chatUserConfigClassName: C.chatUserConfigClassName,
		chatReasoningConfigClassName: C.chatReasoningConfigClassName,
		chatMessageActionsConfigClassName: C.chatMessageActionsConfigClassName,
		chatClassNamesByMode: C.classNamesByMode,
		chatInputFileAttachmentsCustomStyles: C.chatInputFileAttachmentsCustomStyles,
		chatInputFileItemCustomStyles: C.chatInputFileItemCustomStyles,
		chatUserFileAttachmentsCustomStyles: C.chatUserFileAttachmentsCustomStyles,
		chatUserFileItemCustomStyles: C.chatUserFileItemCustomStyles,
		chatClassName: C.chatClassName,
		chatClassNameFloating: C.chatClassNameFloating,
		chatClassNameFullScreen: C.chatClassNameFullScreen,
		chatVoiceInputClassName: C.chatVoiceInputClassName,
		chatVoiceInputClassNameFloating: C.chatVoiceInputClassNameFloating,
		chatVoiceInputClassNameFullScreen: C.chatVoiceInputClassNameFullScreen,
		chatUserVoiceMessageClassName: C.chatUserVoiceMessageClassName,
		chatUserVoiceMessageClassNameFloating: C.chatUserVoiceMessageClassNameFloating,
		chatUserVoiceMessageClassNameFullScreen: C.chatUserVoiceMessageClassNameFullScreen,
		chatHeaderClassName: C.chatHeaderClassName,
		chatHeaderClassNameFloating: C.chatHeaderClassNameFloating,
		chatHeaderClassNameFullScreen: C.chatHeaderClassNameFullScreen,
		chatMessagesClassName: C.chatMessagesClassName,
		chatMessagesClassNameFloating: C.chatMessagesClassNameFloating,
		chatMessagesClassNameFullScreen: C.chatMessagesClassNameFullScreen,
		chatInputAreaClassName: C.chatInputAreaClassName,
		chatInputAreaClassNameFloating: C.chatInputAreaClassNameFloating,
		chatInputAreaClassNameFullScreen: C.chatInputAreaClassNameFullScreen,
		chatUserMessageClassName: C.chatUserMessageClassName,
		chatUserMessageClassNameFloating: C.chatUserMessageClassNameFloating,
		chatUserMessageClassNameFullScreen: C.chatUserMessageClassNameFullScreen,
		chatAgentMessageClassName: C.chatAgentMessageClassName,
		chatAgentMessageClassNameFloating: C.chatAgentMessageClassNameFloating,
		chatAgentMessageClassNameFullScreen: C.chatAgentMessageClassNameFullScreen,
		chatErrorMessageClassName: C.chatErrorMessageClassName,
		chatErrorMessageClassNameFloating: C.chatErrorMessageClassNameFloating,
		chatErrorMessageClassNameFullScreen: C.chatErrorMessageClassNameFullScreen,
		buttonClassName: C.buttonClassName,
		chatHeaderButtonClassName: C.chatHeaderButtonClassName,
		chatHeaderButtonClassNameFloating: C.chatHeaderButtonClassNameFloating,
		chatHeaderButtonClassNameFullScreen: C.chatHeaderButtonClassNameFullScreen,
		chatHistoryClassName: C.chatHistoryClassName,
		chatHistoryClassNameFloating: C.chatHistoryClassNameFloating,
		chatHistoryClassNameFullScreen: C.chatHistoryClassNameFullScreen,
		chatHistoryItemClassName: C.chatHistoryItemClassName,
		chatHistoryItemClassNameFloating: C.chatHistoryItemClassNameFloating,
		chatHistoryItemClassNameFullScreen: C.chatHistoryItemClassNameFullScreen,
		chatHistorySectionClassName: C.chatHistorySectionClassName,
		chatHistorySectionClassNameFloating: C.chatHistorySectionClassNameFloating,
		chatHistorySectionClassNameFullScreen: C.chatHistorySectionClassNameFullScreen,
		textAreaClassName: C.textAreaClassName,
		textAreaClassNameFloating: C.textAreaClassNameFloating,
		textAreaClassNameFullScreen: C.textAreaClassNameFullScreen,
		formTextAreaClassName: C.formTextAreaClassName,
		formErrorClassName: C.formErrorClassName,
		modalClassName: C.modalClassName,
		modalHeaderClassName: C.modalHeaderClassName,
		chatCustomClassName: C.chatCustomClassName,
		chatFloatingCustomClassName: C.chatFloatingCustomClassName,
		chatFullscreenCustomClassName: C.chatFullscreenCustomClassName,
		chatHeaderCustomClassName: C.chatHeaderCustomClassName,
		chatHeaderCustomClassNameFloating: C.chatHeaderCustomClassNameFloating,
		chatHeaderCustomClassNameFullScreen: C.chatHeaderCustomClassNameFullScreen,
		chatMessagesCustomClassName: C.chatMessagesCustomClassName,
		chatMessagesCustomClassNameFloating: C.chatMessagesCustomClassNameFloating,
		chatMessagesCustomClassNameFullScreen: C.chatMessagesCustomClassNameFullScreen,
		chatAgentMessageCustomClassName: C.chatAgentMessageCustomClassName,
		chatAgentMessageCustomClassNameFloating: C.chatAgentMessageCustomClassNameFloating,
		chatAgentMessageCustomClassNameFullScreen: C.chatAgentMessageCustomClassNameFullScreen,
		chatUserMessageCustomClassName: C.chatUserMessageCustomClassName,
		chatUserMessageCustomClassNameFloating: C.chatUserMessageCustomClassNameFloating,
		chatUserMessageCustomClassNameFullScreen: C.chatUserMessageCustomClassNameFullScreen,
		chatInputCustomClassName: C.chatInputCustomClassName,
		chatInputCustomClassNameFloating: C.chatInputCustomClassNameFloating,
		chatInputCustomClassNameFullScreen: C.chatInputCustomClassNameFullScreen,
		chatErrorMessageCustomClassName: C.chatErrorMessageCustomClassName,
		chatHistoryCustomClassName: C.chatHistoryCustomClassName,
		chatHistoryCustomClassNameFloating: C.chatHistoryCustomClassNameFloating,
		chatHistoryCustomClassNameFullScreen: C.chatHistoryCustomClassNameFullScreen,
		chatUserVoiceMessageCustomClassName: C.chatUserVoiceMessageCustomClassName,
		chatUserVoiceMessageCustomClassNameFloating: C.chatUserVoiceMessageCustomClassNameFloating,
		chatUserVoiceMessageCustomClassNameFullScreen: C.chatUserVoiceMessageCustomClassNameFullScreen,
		chatVoiceInputCustomClassName: C.chatVoiceInputCustomClassName,
		chatVoiceInputCustomClassNameFloating: C.chatVoiceInputCustomClassNameFloating,
		chatVoiceInputCustomClassNameFullScreen: C.chatVoiceInputCustomClassNameFullScreen,
		chatErrorMessageCustomClassNameFloating: C.chatErrorMessageCustomClassNameFloating,
		chatErrorMessageCustomClassNameFullScreen: C.chatErrorMessageCustomClassNameFullScreen,
		chatSuggestedPromptsCustomClassName: C.chatSuggestedPromptsCustomClassName,
		chatSuggestedPromptsCustomClassNameFloating: C.chatSuggestedPromptsCustomClassNameFloating,
		chatSuggestedPromptsCustomClassNameFullScreen: C.chatSuggestedPromptsCustomClassNameFullScreen,
		fabCustomClassNameFloating: C.fabCustomClassNameFloating,
		fabCustomClassNameFullScreen: C.fabCustomClassNameFullScreen,
		fabNotificationCustomClassNameFloating: C.fabNotificationCustomClassNameFloating,
		fabNotificationCustomClassNameFullScreen: C.fabNotificationCustomClassNameFullScreen,
		popupPositionClassNameFloating: C.popupPositionClassNameFloating,
		popupPositionClassNameFullscreen: C.popupPositionClassNameFullscreen,
		helperTooltipClassName: C.helperTooltipClassName
	};
}
var $ = (e, t, n, r) => r === _.FLOATING ? t : r === _.FULLSCREEN ? n : e;
function jt(e, t) {
	let n = t?.displayMode ?? _.FILL, r = $(e.chatHeaderClassName, e.chatHeaderClassNameFloating, e.chatHeaderClassNameFullScreen, n), i = $(e.chatMessagesClassName, e.chatMessagesClassNameFloating, e.chatMessagesClassNameFullScreen, n), a = $(e.chatInputAreaClassName, e.chatInputAreaClassNameFloating, e.chatInputAreaClassNameFullScreen, n), o = $(e.chatUserMessageClassName, e.chatUserMessageClassNameFloating, e.chatUserMessageClassNameFullScreen, n), s = $(e.chatAgentMessageClassName, e.chatAgentMessageClassNameFloating, e.chatAgentMessageClassNameFullScreen, n), c = $(e.chatErrorMessageClassName, e.chatErrorMessageClassNameFloating, e.chatErrorMessageClassNameFullScreen, n), l = $(e.chatUserVoiceMessageClassName, e.chatUserVoiceMessageClassNameFloating, e.chatUserVoiceMessageClassNameFullScreen, n), u = $(e.chatVoiceInputClassName, e.chatVoiceInputClassNameFloating, e.chatVoiceInputClassNameFullScreen, n), d = $(e.textAreaClassName, e.textAreaClassNameFloating, e.textAreaClassNameFullScreen, n), f = $(e.chatHeaderButtonClassName, e.chatHeaderButtonClassNameFloating, e.chatHeaderButtonClassNameFullScreen, n), p = $(e.chatHistoryClassName, e.chatHistoryClassNameFloating, e.chatHistoryClassNameFullScreen, n), m = $(e.chatHistoryCustomClassName, e.chatHistoryCustomClassNameFloating, e.chatHistoryCustomClassNameFullScreen, n), h = $(e.chatHistoryItemClassName, e.chatHistoryItemClassNameFloating, e.chatHistoryItemClassNameFullScreen, n), g = $(e.chatHistorySectionClassName, e.chatHistorySectionClassNameFloating, e.chatHistorySectionClassNameFullScreen, n), v = n === _.FLOATING ? "floating" : n === _.FULLSCREEN ? "fullscreen" : "fill", y = e.chatIconsByMode[n], b = [e.chatClassNamesByMode[n].chatInputFileAttachments, e.chatClassNamesByMode[n].chatInputFileItem].filter(Boolean).join(" ") || "", x = [...e.chatInputFileAttachmentsCustomStyles[v], ...e.chatInputFileItemCustomStyles[v]], S = [e.chatClassNamesByMode[n].chatUserFileAttachments, e.chatClassNamesByMode[n].chatUserFileItem].filter(Boolean).join(" ") || "", C = [...e.chatUserFileAttachmentsCustomStyles[v], ...e.chatUserFileItemCustomStyles[v]], w = e.chatClassNamesByMode[n].chatMessageActions ?? "", E = [e.chatClassNamesByMode[n].chatMessageFeedback, e.chatClassNamesByMode[n].chatMessageFeedbackReason].filter(Boolean).join(" ") || "", D = (() => {
		if (e.chatConfig.showAgentAvatar) return y.agentIcon ? {
			src: y.agentIcon,
			alt: "Chat agent icon"
		} : e.chatHeaderAvatar;
	})();
	return {
		messages: e.messages,
		reasoning: e.reasoning,
		showSuggestedPrompts: e.showSuggestedPrompts,
		agentSuggestions: e.agentSuggestions,
		hasMoreMessages: e.hasMoreMessages,
		loadingMore: e.loadingMore,
		onLoadMore: e.handleLoadMore,
		config: e.chatConfig,
		avatars: {
			header: e.chatHeaderAvatar,
			agent: D
		},
		icons: y,
		onSendMessage: e.handleSendMessage,
		onSendSuggestedPrompt: e.handleSendSuggestedPrompt,
		onSendConfiguredPrompt: e.handleSendConfiguredPrompt,
		onMessageCopied: e.chatAnalytics.messageCopied,
		onStopResponse: e.handleStopResponse,
		inputDisabled: e.inputDisabled,
		inputDisabledTooltip: e.inputDisabledTooltip,
		onNewChat: e.chatConfig.hideNewConversation ? void 0 : e.handleNewChat,
		onRegenerate: e.handleRegenerate,
		onVoiceMessage: e.handleVoiceMessage,
		showVoiceInput: e.chatInputFlowxProps?.voiceInputEnabled ?? !1,
		showFileUpload: e.fileUploadConfig.showFileUpload,
		fileAccept: e.fileUploadConfig.accept,
		fileMaxFiles: e.fileUploadConfig.maxFiles,
		fileMaxFilesSize: e.fileUploadConfig.maxFilesSize,
		fileInvalidTypeError: e.fileUploadConfig.invalidTypeError,
		fileCountExceededError: e.fileUploadConfig.countExceededError,
		fileSizeExceededError: e.fileUploadConfig.sizeExceededError,
		attachments: e.attachments,
		onAttachmentsChange: e.onAttachmentsChange,
		onAttachmentsMessage: e.handleAttachmentsMessage,
		attachmentsUploadError: e.attachmentsUploadError,
		attachmentsLabels: e.attachmentsLabels,
		attachmentsDataTestId: e.fileUploadConfig.dataTestId,
		fileItemDataTestId: e.fileUploadConfig.fileItemDataTestId,
		userAttachedFilesDataTestId: e.userAttachedFilesDataTestId,
		userFileItemDataTestId: e.userFileItemDataTestId,
		dataTestIds: e.dataTestIds,
		messageActionsConfig: e.messageActionsConfig,
		messageTimeGroupLabels: e.messageTimeGroupLabels,
		locale: T()?.locale,
		feedbackTarget: e.feedbackTarget,
		onFeedbackChange: (t, n) => e.handleFeedbackChange(t, n, e.messages.find((e) => e.messageId === t && e.sender === "receiver")?.feedback ?? null),
		onFeedbackSubmit: e.handleFeedbackSubmit,
		onFeedbackRemove: e.handleFeedbackRemove,
		onFeedbackCancel: e.handleFeedbackCancel,
		downloadFile: e.downloadAttachment,
		activeView: e.activeView,
		onHistory: e.chatConfig.hideHistory ? void 0 : e.handleOpenHistory,
		onBackFromHistory: e.handleCloseHistory,
		chatSessions: e.isSearchActive ? e.searchSessions : e.chatSessions,
		onSelectSession: e.handleSelectSession,
		onLoadMoreSessions: e.handleLoadMoreSessions,
		hasMoreSessions: !e.isSearchActive && e.hasMoreSessions,
		loadingMoreSessions: e.isSearchActive ? e.searchLoading : e.loadingMoreSessions,
		emptyStateText: e.isSearchActive ? e.searchLoading ? "" : e.conversationsNoResultsText : e.conversationsEmptyStateText,
		searchValue: e.searchText,
		onSearchChange: e.handleSearchChange,
		onSearchClear: e.handleSearchClear,
		searchPlaceholder: e.searchPlaceholder,
		searchClearAriaLabel: e.searchClearAriaLabel,
		searchHighlightText: e.searchHighlightText,
		sessionGroupLabels: e.sessionGroupLabels,
		headerTooltips: e.headerTooltips,
		voiceLabels: e.voiceLabels,
		headerControls: t?.headerControls,
		sendAriaLabel: N("@@sys_a11y_chat_submit_message"),
		sendTooltip: N("@@sys_chat_submit_message"),
		stopAriaLabel: N("@@sys_a11y_chat_cancel_request"),
		stopTooltip: N("@@sys_chat_cancel_request"),
		voiceMicAriaLabel: N("@@sys_a11y_chat_voice_input_record"),
		onToggleFullscreen: t?.onToggleFullscreen,
		isFullscreen: t?.isFullscreen,
		showFullscreenToggle: t?.showFullscreenToggle,
		onClose: t?.onClose,
		displayMode: v,
		headerActionIcons: e.headerActionIconsByMode[n],
		hideHeader: e.chatConfig.hideHeader,
		classNames: {
			header: r ?? "",
			headerCustom: $(e.chatHeaderCustomClassName, e.chatHeaderCustomClassNameFloating, e.chatHeaderCustomClassNameFullScreen, n) ?? [],
			headerConfig: e.chatHeaderConfigClassName ?? void 0,
			messages: i ?? "",
			messagesCustom: $(e.chatMessagesCustomClassName, e.chatMessagesCustomClassNameFloating, e.chatMessagesCustomClassNameFullScreen, n) ?? [],
			messagesConfig: e.chatMessagesConfigClassName ?? void 0,
			messageActions: w,
			messageActionsConfig: e.chatMessageActionsConfigClassName ?? void 0,
			messageFeedback: E,
			input: a ?? "",
			inputCustom: $(e.chatInputCustomClassName, e.chatInputCustomClassNameFloating, e.chatInputCustomClassNameFullScreen, n) ?? [],
			inputConfig: e.chatInputConfigClassName ?? void 0,
			userMessage: o ?? "",
			agentMessage: s ?? "",
			userMessageCustom: $(e.chatUserMessageCustomClassName, e.chatUserMessageCustomClassNameFloating, e.chatUserMessageCustomClassNameFullScreen, n) ?? [],
			agentMessageCustom: $(e.chatAgentMessageCustomClassName, e.chatAgentMessageCustomClassNameFloating, e.chatAgentMessageCustomClassNameFullScreen, n) ?? [],
			agentConfig: e.chatAgentConfigClassName ?? void 0,
			userConfig: e.chatUserConfigClassName ?? void 0,
			errorMessage: c ?? "",
			errorMessageCustom: $(e.chatErrorMessageCustomClassName, e.chatErrorMessageCustomClassNameFloating, e.chatErrorMessageCustomClassNameFullScreen, n) ?? [],
			userVoiceMessage: l ?? "",
			userVoiceMessageCustom: $(e.chatUserVoiceMessageCustomClassName, e.chatUserVoiceMessageCustomClassNameFloating, e.chatUserVoiceMessageCustomClassNameFullScreen, n) ?? [],
			voiceInput: u ?? "",
			voiceInputCustom: $(e.chatVoiceInputCustomClassName, e.chatVoiceInputCustomClassNameFloating, e.chatVoiceInputCustomClassNameFullScreen, n) ?? [],
			inputFileAttachments: b,
			inputFileAttachmentsCustom: x,
			userFileAttachments: S,
			userFileAttachmentsCustom: C,
			reasoning: s ?? "",
			suggestedPrompts: [
				H($(B.ChatSuggestedPrompts, B.ChatSuggestedPromptsFloating, B.ChatSuggestedPromptsFullScreen, n)),
				H($(B.ChatSuggestedPromptsSection, B.ChatSuggestedPromptsSectionFloating, B.ChatSuggestedPromptsSectionFullScreen, n)),
				H($(B.ChatSuggestedPromptsItem, B.ChatSuggestedPromptsItemFloating, B.ChatSuggestedPromptsItemFullScreen, n))
			].filter(Boolean).join(" ") || null,
			suggestedPromptsCustom: $(e.chatSuggestedPromptsCustomClassName, e.chatSuggestedPromptsCustomClassNameFloating, e.chatSuggestedPromptsCustomClassNameFullScreen, n) ?? [],
			helperTooltip: H(B.HelperTooltip),
			button: e.buttonClassName ?? "",
			headerButton: f ?? "",
			textArea: d ?? "",
			feedbackTextArea: e.formTextAreaClassName ?? "",
			feedbackError: e.formErrorClassName ?? "",
			feedbackModal: e.modalClassName ?? "",
			feedbackModalHeader: e.modalHeaderClassName ?? "",
			history: p ?? "",
			historyCustom: m ?? [],
			historyItem: h ?? "",
			historyItemTooltip: e.helperTooltipClassName ?? "",
			historySection: g ?? "",
			historySearch: e.chatClassNamesByMode[n].chatHistorySearch ?? "",
			headerTooltip: e.helperTooltipClassName ?? ""
		}
	};
}
//#endregion
//#region libs/sdk/react/src/components/ui-wrapper/chat/FlxChatWrapperFillMode.tsx
var Mt = (e) => {
	let { flowxUuid: t, className: n, chatClassName: r, chatCustomClassName: i, dataTestId: a, displayOptions: s } = e;
	dt({ isOpen: !0 });
	let c = f(null), l = (s?.style)?.fill?.heightType === "fill", u = o(c, l, [i.join(" ")]);
	return /* @__PURE__ */ K(G, {
		ref: c,
		"data-uniqueid": t,
		className: L(r, ...i, n),
		"data-testid": a,
		style: u ? { height: u } : void 0,
		children: /* @__PURE__ */ K(lt, { ...jt(e) })
	});
}, Nt = ({ canToggleMode: e, initialFullscreen: t, initialOpen: n = !1 }) => {
	let [r, i] = p(n), [a, o] = p(t ? _.FULLSCREEN : _.FLOATING);
	u(() => {
		t && o(_.FULLSCREEN);
	}, [t]);
	let s = c(() => {
		o((e) => e === _.FLOATING ? _.FULLSCREEN : _.FLOATING);
	}, []), l = c(() => i(!1), []);
	return {
		isOpen: r,
		setIsOpen: i,
		currentMode: a,
		isFullscreen: a === _.FULLSCREEN,
		toggleMode: e ? s : void 0,
		closeChat: l
	};
}, Pt = (e) => d(() => {
	let t = H(B.ChatFabFloating), n = H(B.ChatFabFullScreen), r = H(B.ChatFabNotificationFloating), i = H(B.ChatFabNotificationFullScreen), a = H(B.Button), o = V(B.ChatFabFloating, "fabChatIcon"), s = V(B.ChatFabFullScreen, "fabChatIcon"), c = o ? A(o) : null, l = s ? A(s) : null;
	return {
		fabClassName: t,
		fabFullScreenClassName: n,
		fabNotificationClassName: r,
		fabNotificationFullScreenClassName: i,
		buttonClassName: a,
		fabIconPath: (e ? l : c) ?? null,
		fabIconFallbackName: e ? "caretDown" : "arrowUp"
	};
}, [e]), Ft = (e) => {
	let { flowxUuid: t, chatClassNameFloating: n, chatClassNameFullScreen: r, chatFloatingCustomClassName: i, chatFullscreenCustomClassName: a, fabCustomClassNameFloating: o, fabCustomClassNameFullScreen: s, fabNotificationCustomClassNameFloating: c, fabNotificationCustomClassNameFullScreen: l, popupPositionClassNameFloating: u, popupPositionClassNameFullscreen: d, canToggleMode: f, initialFullscreen: p = !1, initialOpen: m = !1, dataTestId: h, chatAnalytics: g } = e, v = Nt({
		canToggleMode: f,
		initialFullscreen: p,
		initialOpen: m
	}), y = Pt(v.isFullscreen), b = st(), x = v.isFullscreen && b != null, S = v.isFullscreen ? r : n, C = v.isFullscreen ? s : o, w = v.isFullscreen ? l : c, T = dt({ isOpen: v.isOpen }), E = (e, t) => {
		if (!e && (t.reason === "outside-press" || t.reason === "focus-out")) {
			t.cancel();
			return;
		}
		e && !v.isOpen && g.chatOpened(), v.setIsOpen(e);
	}, D = {
		onClose: v.closeChat,
		showFullscreenToggle: f,
		displayMode: v.isFullscreen ? _.FULLSCREEN : _.FLOATING,
		...f ? {
			onToggleFullscreen: v.toggleMode,
			isFullscreen: v.isFullscreen
		} : {}
	};
	return /* @__PURE__ */ Ye(q.Root, {
		modal: v.isFullscreen,
		open: v.isOpen,
		onOpenChange: E,
		children: [/* @__PURE__ */ K(q.Trigger, { render: /* @__PURE__ */ Ye("button", {
			type: "button",
			className: L("flx-chat-fab", "flx-chat-fab-fullscreen", y.buttonClassName, y.fabClassName, v.isFullscreen && y.fabFullScreenClassName, ...C),
			"data-testid": h ? `${h}-fab` : "chat-fab",
			"aria-label": "Open chat",
			children: [y.fabIconPath ? /* @__PURE__ */ K(Ke, { path: y.fabIconPath }) : /* @__PURE__ */ K(Ke, { name: y.fabIconFallbackName }), T > 0 && !v.isOpen && /* @__PURE__ */ K("span", {
				className: L("flx-chat-fab-notification", v.isFullscreen && "flx-chat-fab-notification-fullscreen", y.fabNotificationClassName, v.isFullscreen && y.fabNotificationFullScreenClassName, ...w),
				children: T > 9 ? "9+" : T
			})]
		}) }), /* @__PURE__ */ Ye(q.Portal, {
			container: b?.current,
			children: [v.isFullscreen && /* @__PURE__ */ K(q.Backdrop, { className: L("flx-chat-backdrop", x && "flx-chat-backdrop-in-container") }), /* @__PURE__ */ K(q.Positioner, {
				positionMethod: "fixed",
				className: L("flx-chat-positioner", v.isFullscreen ? "flx-chat-positioner-fullscreen" : "flx-chat-positioner-floating", x && "flx-chat-positioner-fullscreen-in-container", v.isFullscreen ? d : u),
				children: /* @__PURE__ */ K(q.Popup, {
					className: L("flx-chat-popup", v.isFullscreen ? "flx-chat-popup-fullscreen" : "flx-chat-popup-floating", x && "flx-chat-popup-fullscreen-in-container", ...v.isFullscreen ? a : i),
					children: /* @__PURE__ */ K(G, {
						"data-uniqueid": t,
						className: L(S ?? ""),
						"data-testid": h,
						"data-fullscreen": v.isFullscreen,
						children: /* @__PURE__ */ K(lt, { ...jt(e, D) })
					})
				})
			})]
		})]
	});
}, It = (e) => d(() => {
	let t = e?.displayTypes, n = t?.includes(_.FLOATING) ?? !1, r = t?.includes(_.FULLSCREEN) ?? !1;
	return {
		displayTypes: t,
		hasFloating: n,
		hasFullscreen: r,
		isFillMode: !t?.length || t.length === 1 && t[0] === _.FILL,
		canToggleMode: !!(n && r),
		initialFullscreen: r && !n
	};
}, [e?.displayTypes]), Lt = /* @__PURE__ */ Y({
	FlxChatWrapper: () => Rt,
	default: () => Rt,
	defaultChatConfig: () => mt,
	useFlxChatWrapperState: () => At
}), Rt = ({ config: e, initialOpen: t }) => {
	let n = At(e), r = It(n.flowxProps);
	return r.isFillMode ? /* @__PURE__ */ K(Mt, {
		...n,
		dataTestId: n.flowxProps?.dataTestId
	}) : /* @__PURE__ */ K(Ft, {
		...n,
		canToggleMode: r.canToggleMode,
		initialFullscreen: r.initialFullscreen,
		initialOpen: t,
		dataTestId: n.flowxProps?.dataTestId
	});
};
//#endregion
export { ct as a, nt as c, vt as i, Y as l, Lt as n, ot as o, yt as r, at as s, Rt as t, it as u };
